var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"disabled":_vm.menuIsDisabled},on:{"click":_vm.generatePicturesExport}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.btnText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }